@if (prompt.open()) {
  <app-modal
    [title]="'common.unsaved_changes.title' | translate"
    [config]="config()"
    (closeModal)="prompt.answer(false)">
    <p modal-body class="text-text-secondary text-sm">
      {{ 'common.unsaved_changes.message' | translate }}
    </p>
  </app-modal>
}
